import React, { Component } from 'react';
import {getTicketListSuministroElectrico} from '../api.js';
import ContentBox from './ContentBox.js';
import {ClientSelectSuministroElectrico} from './ClientSelectSuministroElectrico';
import DatePicker from "react-datepicker";
import calendar from "../img/calendar.svg";
import moment from "moment";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import Paginator from './Paginator';
import PostFileDownloadDocument from './PostFileDownloadDocument';
export default class ServiciosSuministroElectricoHistorialFacturas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchType: "days",
      searchPedido: "",
      filterDays: "30",
      checkers: [],
      page: 1,
      itemsPerPage: 10,
      startDate: (() => {
              const date = new Date();
              date.setFullYear(date.getFullYear() - 1);
              return date;
            })(),
      endDate: new Date()
    };
    this.getList = this.getList.bind(this);
    this.filter = this.filter.bind(this);
  }
  componentDidMount() {
    if(this.props.reloadServices) this.props.reloadServices();
    if(this.props.selectedService) this.getList();
  }
  componentDidUpdate(prevProps, prevState) {
    if(prevProps.selectedService !== this.props.selectedService) this.getList();
    if (prevState.checkers !== this.state.checkers && this.state.checkers.length > 0) {
      let allLoaded = true;
      this.state.checkers.map(el =>{
        if (el.status === false) {
          allLoaded = false
        }
      })
      if (allLoaded) {
        this.setState({loading: false})
      }
    }
  }
  getList(cb) {
    this.setState({formErrors: null, loading: true, tickets: null, page: 1, pedidosMessage: "", checkers: []});
    getTicketListSuministroElectrico(this.props.selectedService.abastible_contract_id, moment(this.state.startDate).format("YYYY-MM-DD"), moment(this.state.endDate).format("YYYY-MM-DD")  , (error, result) => {
      if(error) {
        if(cb) cb(error);
        this.setState({loading: false});
        return console.log(error);
      }
      if(result.status === "error") {
        if(cb) cb();
        return this.setState({loading: false, formErrors: result.errors});
      }
      if(result.status === "empty") {
        if(cb) cb();
        return this.setState({loading: false, pedidosMessage: result.message});
      }
      this.setState({tickets: result.data});
      this.loadRenderedItems(this.state.page)
    }, this.props.isEmpresa?"empresas":null);
  }
  filter() {
    this.getList();
  }
  changePage(page) {
    this.setState({page, loading: true});
    this.loadRenderedItems(page)
  }
  loadRenderedItems(page) {
    let itemsRendered = [];
    this.state.tickets.slice((page - 1)*this.state.itemsPerPage, (page - 1)*this.state.itemsPerPage + this.state.itemsPerPage).map(el=>{
      itemsRendered = [...itemsRendered, {pdf_id: el.Numerodocto, status: false}]
    })
    this.setState({checkers: itemsRendered})
  }
  isChecked(id) {
    this.state.checkers.map((el, i)=>{
      if (el.pdf_id === id) {
        let array = [...this.state.checkers];
        array[i] = { ...array[i], status: true };
        this.setState({ checkers: array });
      }
    })
  }
  render() {
    return (
      <ContentBox loading={this.state.loading}>
        <div className="title-client-container clearfix">
          <h1>Historial de Facturas</h1>
          <div className="client-number">
            <ClientSelectSuministroElectrico
              selected={this.props.selectedService}
              services={this.props.services}
              setSelected={this.props.setSelectedService}
              number_field={"abastible_contract_id"} />
          </div>
        </div>
        <div className="col-100 left d-flex justify-between margin-bottom-40">
          <div className="filter-container grid-column-3">
            <div className="position-relative">
              <img className="calendar" src={calendar} alt="calendario" />
              <DatePicker
                popperModifiers={{ flip: { enabled: false } }}
                maxDate={this.state.endDate}
                dateFormat="dd/MM/yyyy"
                placeholderText="Desde"
                selected={this.state.startDate}
                locale="es"
                onChange={(date) => {
                  this.setState({startDate: date});
                  this.setState({formErrors: null});
                  this.setState({pedidosMessage: null});
                }}
              />
            </div>
            <div className="position-relative">
              <img className="calendar" src={calendar} alt="calendario" />
              <DatePicker
                popperModifiers={{ flip: { enabled: false } }}
                minDate={this.state.startDate}
                maxDate={new Date()}
                dateFormat="dd/MM/yyyy"
                placeholderText="Hasta"
                selected={this.state.endDate}
                locale="es"
                onChange={(date) => {
                  this.setState({endDate: date});
                  this.setState({formErrors: null});
                  this.setState({pedidosMessage: null});
                }}
              />
            </div>
            <button
              className="button orange"
              onClick={this.getList}
              disabled={this.props.loading}
            >
              {this.props.loading ? "Cargando..." : "Filtrar"}
            </button>
          </div>
        </div>
        <div className="table-container">
          <table className="table1">
            <thead>
              <tr>
                <td>Nro. Documento</td>
                <td>Fecha Emisión</td>
                <td>Monto</td>
                <td>Fecha Vencimiento</td>
                <td style={{maxWidth: '70px', padding: '0px'}}></td>
              </tr>
            </thead>
            <tbody>
              {!this.state.tickets?null:this.state.tickets.slice((this.state.page - 1)*this.state.itemsPerPage, (this.state.page - 1)*this.state.itemsPerPage + this.state.itemsPerPage).map((ticket, i) => {
                return(
              <tr key={ticket.Numerodocto}>
                <td>{ticket.Numerodocto}</td>
                <td>{ticket.Fechaemision}</td>
                <td>${parseInt(ticket.Monto).toLocaleString("de")}</td>
                <td>{ticket.Fechavencimiento}</td>
                <td style={{maxWidth: '70px', paddingLeft: '0px'}}>
                {ticket.Numerodocto?<PostFileDownloadDocument 
                  key={`${this.props.selectedService.abastible_contract_id}-${ticket.Numerodocto}`}
                  contract_cod={this.props.selectedService.abastible_contract_id}
                  createActionNotification={this.props.createActionNotification} 
                  class_description={'FACTURA'} 
                  isEmpresa={true}
                  doCheck={true}
                  isChecked={this.isChecked.bind(this)}

                  pdf_number={(ticket.Numerodocto)} contentRender={() => 
                  <div className="linkA-container">
                    <a>Descargar Documento</a>
                  </div>
                } />:null}
                </td>
              </tr>);

              })}
            </tbody>
          </table>
          {!this.state.tickets?<p>{this.state.pedidosMessage}</p>:null}
        </div>
        {this.state.tickets && this.state.tickets.length > this.state.itemsPerPage?<Paginator page={this.state.page} items={this.state.tickets?this.state.tickets.length:0} itemsPerPage={this.state.itemsPerPage} onPageChange={(page) => this.changePage(page)} />:null}          
      </ContentBox>
    );
  }
}
